import { graphql } from '~/gql';

// Shared Task query used by task view routes
export const TaskDocument = graphql(`
  query Task($id: ID!) {
    task(id: $id) {
      id
      required
      type
      status
      name
      description
      tags {
        nodes {
          id
          entityType
          name
          category
          description
          colour
        }
      }
      attributes {
        id
        type
        category
        name
        value
        attachments {
          id
          kind
          ext
          thumb
          url
          originalFilename
        }
      }
      jobAttributeIds
      taskAttributes {
        id
        value
      }
      notes
      attachments {
        ...AttachmentFields
      }
      job {
        id
      }
      config {
        selection
        spaces
        assetTypes
        allow
        shareAttributes
        shareJobHistory
        shareDeploymentHistory
      }
      assets {
        id
        name
        image
        type
        model {
          id
          displayName
        }
        deployment {
          id
          image
          location {
            id
            name
          }
          space {
            id
            name
          }
        }
      }
      purchase {
        id
        spaces
        movements {
          id
          qty
        }
      }
      stocktake {
        id
        include
        itemStatus
        spaces
        items {
          id
          adjustment
          newOnHand
        }
      }
      stockTransfer {
        id
        rule
        items {
          id
          spaceId
          skuId
          pick
          picked
          packed
          dispatched
          received
          putAway
        }
      }
      transfer {
        available {
          id
          qty
        }
        moved {
          id
          qty
        }
        stockOnHand {
          # ...spaceSkuData
          id
          reserved
          soh
          target
          capacity
          reorderLevel
          space {
            id
            name
            location {
              __typename
              id
              name
            }
            attributes {
              name
              value
            }
          }
          sku {
            id
            code
            name
            itemType
            image
            attributes {
              name
              value
            }
          }
        }
      }
      ...AttributeTask
    }
  }
`);
